import React, { useContext, useEffect, useState } from 'react';
import './ProductCardHorizontal.css';
import { ConfigContext } from '../../../assets/contexts/configContext';
import { Link, useNavigate } from 'react-router-dom';
import { ARTICL_NAME, CART_MAIN_LINK, CATALOG_ITEM_LINK, CATALOG_MAIN_LINK, IMG_PLACEHOLDER_PRODUCT, RECENTLY_VIEW_LS_KEY } from '../../../assets/utils/constants';
import { buildCategoryPath, compareOptions, getMinPrice, parsePrice, parseTitleForParts } from '../../../assets/utils/utils';
import { CartIcon } from '../../../assets/icons/icons';
import ImageWithBackground from '../../ImageWithBackground/ImageWithBackground';
import { CartContext } from '../../../assets/contexts/cartContext';

const WATCH_CASE = 'Body material'
const DIAMETER = 'Body diameter'
const GLASS = 'Glass'

// The parameters you want to display in that order
const DESIRED_PARAMETERS = [WATCH_CASE, DIAMETER, GLASS];


function ProductCardHorizontal({
    item, path
}) {

    const config = useContext(ConfigContext)
    const { cardTokens, initialConstants } = config
    const { CONSTANTS } = initialConstants
    const { ENABLE_PHOTO_AUTOADJUST = true } = CONSTANTS
    const {
        // cards_in_line,
        but_btn_format,
        image_format,
        image_radius,
        layout,
        price_format,
    } = cardTokens
    // Reverse the array and store it
    const reversedArray = [...item.categories[0].parents].reverse();

    // const [bgColor, setBgColor] = useState('transparent');

    // useEffect(() => {
    //     Vibrant.from(src).getPalette()
    //       .then(palette => {
    //         const rgbColor = palette.Vibrant?.getRgb();
    //         if (rgbColor) {
    //           setBgColor(`rgb(${rgbColor[0]}, ${rgbColor[1]}, ${rgbColor[2]})`);
    //         }
    //       })
    //       .catch(err => console.error('Error extracting color:', err));
    //   }, [src]);

    const cart_context = useContext(CartContext)
    const {
        cart,
        handleAddToCart,
        handleRemoveFromCart,
        // setCart,
    } = cart_context


    const inCart = item && cart && cart.find((cart_item) => {
        if (cart_item._id !== item._id) {
            return false; // Skip items with a different ID early
        }
        // If the item has options and selectedOptions are provided, compare them
        if (cart_item.options && cart_item.options.length > 0) {
            return false
        } else {
            // If there are no options to compare, just check the _id
            return true;
        }
    });
    const navigate = useNavigate()
    const in_stock = item ? item.options.length === 1 ? true : item.price_data.in_stock : null
    function handleCartClick(e) {
        if (!in_stock) return
        if (!item.options || item.options.length === 0) {
            e.preventDefault(); // Prevent default button action
            e.stopPropagation(); // Stop the event from bubbling up
            if (inCart) {
                navigate(`/${CART_MAIN_LINK}`);
                return;
            }
            console.log(item)
            const product_to_card = {
                ...item,
                options: null,
                // selected_size: selectedSize,
                count: 1,
            };
            console.log(product_to_card);
            handleAddToCart(product_to_card);
        }
    }

    const in_cart_text = inCart ? 'В корзине ›' : 'В корзину'
    const price = item.options && item.options.length === 1 ? getMinPrice(item.options[0].values) : item.price_data.price
    // console.log(item?.parameters.find((item) => item.name === 'Артикул'))
    function saveRecentlyView() {
        let arr = JSON.parse(localStorage.getItem(RECENTLY_VIEW_LS_KEY)) || [];
        const newItem = item._id;
        if (!newItem) {
            return;
        }
        const index = arr.indexOf(newItem);
        if (index !== -1) {
            arr.splice(index, 1);
        }
        arr.push(newItem);
        localStorage.setItem(RECENTLY_VIEW_LS_KEY, JSON.stringify(arr));


    }

    const foundParams = DESIRED_PARAMETERS
        .map((paramName) => {
            // Look for param in the item

            const foundParam = item?.parameters?.find((p) => p.name === paramName);
            // If found, return its value; if not, return null
            return foundParam ?
                foundParam.value?.includes('gold') || foundParam.value?.includes('Gold') ? 'Gold'
                    : foundParam.value?.includes('steel') || foundParam.value?.includes('Steel') ? 'Steel'
                        : foundParam.value?.includes('carbon') || foundParam.value?.includes('Carbon') ? 'Carbon'
                            : foundParam.value?.includes('platinum') || foundParam.value?.includes('Platinum') ? 'Platinum'
                                : foundParam.value?.includes('titanium') || foundParam.value?.includes('Titanium') ? 'Titanium'
                                    : foundParam.name !== WATCH_CASE ? foundParam.value : null : null
        })
        // Remove null or undefined items
        .filter(Boolean);

    const [isLiked, setIsLiked] = useState(false);

    // Utility functions for managing local storage
    const getLikedProducts = () => JSON.parse(localStorage.getItem('likedProducts')) || [];
    const saveLikedProducts = (likedProducts) => localStorage.setItem('likedProducts', JSON.stringify(likedProducts));

    // Check if the product is liked on component mount
    useEffect(() => {
        const likedProducts = getLikedProducts();
        setIsLiked(likedProducts.includes(item._id));
    }, [item._id]);

    // Handle like button click
    const handleLikeClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const likedProducts = getLikedProducts();
        if (likedProducts.includes(item._id)) {
            // Remove from liked products
            const updatedLikedProducts = likedProducts.filter((id) => id !== item._id);
            saveLikedProducts(updatedLikedProducts);
            setIsLiked(false);
        } else {
            // Add to liked products
            likedProducts.push(item._id);
            saveLikedProducts(likedProducts);
            setIsLiked(true);
        }
    };

    return (
        <Link onClick={saveRecentlyView} className='product-card-horizontal' to={`/${CATALOG_MAIN_LINK}/${buildCategoryPath(reversedArray, item.categories[0].parents.length - 1)}/${CATALOG_ITEM_LINK}/${item._id}`}>
            <button className={`product-card-horizontal__like ${isLiked ? 'product-card-horizontal__like_active' : ''}`} type='button' onClick={handleLikeClick}>
                <svg className='product-card-horizontal__like-icon' width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className='product-card-horizontal__like-icon-fill-and-stroke' d="M17.5173 3C21.3979 3 24 6.725 24 10.1938C24 17.235 13.1968 23 13 23C12.8032 23 2 17.235 2 10.1938C2 6.725 4.60211 3 8.48267 3C10.701 3 12.1579 4.13125 13 5.13875C13.8421 4.13125 15.299 3 17.5173 3Z" fill="white" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
            {item.price_data.discount && item.price_data.discount > 0 ?
                <h3 className='product-card-horizontal__price-discount'>-{item.price_data.discount}%</h3>
                :
                null
            }
            < ImageWithBackground
                className={`product-card-horizontal__image product-card-horizontal__image_format_10x16`}
                src={item.files && item.files.length > 0 ? item.files[0]?.urls.orig : IMG_PLACEHOLDER_PRODUCT}
                image_format={'10x16'}
                key={`${item.files && item.files.length > 0 ? item.files[0]?.urls.orig : IMG_PLACEHOLDER_PRODUCT}${item._id}`}
                metadata={item.files && item.files.length > 0 ? item.files[0]?.metadata : null}
                isVideo={item.files[0]?.metadata?.first_frame_db ? true : false}
            />
            <div className='product-card-horizontal__additional'>
                {item.parameters?.find((item2) => item2.name === '_promo')?.value ? <p className='product-card-horizontal__additional-promo'>{item.parameters?.find((item2) => item2.name === '_promo')?.value}</p> : <div />}
                {item.parameters?.find((item2) => item2.name === 'Condition')?.value ? <p className='product-card-horizontal__additional-condition'>{item.parameters?.find((item2) => item2.name === 'Condition')?.value}</p> : <div className='product-card-horizontal__additional-condition-placeholder' />}
            </div>
            <div className='product-card-horizontal__info'>

                <h3 className={`product-card-horizontal__title`}>{item.name && item.name.length > 0 ? parseTitleForParts(item.name).title : ` `}</h3>
                <p className={`product-card-horizontal__subtitle`}>{item.name && item.name.length > 0 ? parseTitleForParts(item.name).subtitle : ` `}</p>

                <div className='product-card-horizontal__reference-and-price'>

                    {
                        item?.parameters?.find((item2) => item2.name === ARTICL_NAME)
                            ?
                            <div className='product-card-horizontal__reference-title'>
                                <p className='product-card-horizontal__reference'>Reference:</p>
                                <p className='product-card-horizontal__reference-value'>{item?.parameters?.find((item2) => item2.name === ARTICL_NAME).value}</p>
                            </div>
                            :
                            <div className='roduct-card-hero__reference-placeholder'>

                            </div>
                    }
                    <button className={`product-card-horizontal__button   `} type='button'>

                        {price && Number(price) !== 0 && Number(price) !== 1 ?
                            item.price_data.discount && item.price_data.discount > 0 ?
                                <h3 className='product-card-horizontal__button-price product-card-horizontal__button-price_discount'><span className='product-card-horizontal__button-price-discounted'>{parsePrice(Number(price), 'USD')}</span> {item.options && item.options.length === 1 ? 'from ' : ''}{parsePrice(Math.round(Number(price) - Number(price) / 100 * Number(item.price_data.discount)), 'USD')}</h3>
                                :
                                <h3 className='product-card-horizontal__button-price'>{item.options && item.options.length === 1 ? 'from ' : ''}{parsePrice(price, 'USD')}</h3>
                            :
                            <h3 className='product-card-horizontal__button-price-request'>On Request</h3>
                        }

                        {/* } */}
                    </button>
                </div>
            </div>
            <div className='product-card-horizontal__cart-btn'>
                <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.36987 1V11.8922" stroke="white" stroke-width="1.59231" stroke-linecap="round" />
                    <path d="M1 6.44531L13.7385 6.44531" stroke="white" stroke-width="1.59231" stroke-linecap="round" />
                </svg>

            </div>

        </Link>
    );
}

export default ProductCardHorizontal